import {
  OPTIMIZE_ROUTES,
  GET_TASK_STATUS,
  GET_ROUTES_BY_DATE,
  REORDER_ROUTE,
  INSERT_JOB_TO_ROUTE,
  UPDATE_JOB_LOCATION,
  COMPARE_ROUTE_STRATEGIES,
  LOCK_ROUTE,
  DELETE_ROUTE,
  OPTIMIZE_FROM_LOCATION,
  CLEAR_ROUTE_OPTIMIZATION_STATE,
  SET_SELECTED_ROUTE,
  CLEAR_SELECTED_ROUTE,
} from '../../modules/constants';

export function optimizeRoutes(value) {
  return {
    type: OPTIMIZE_ROUTES,
    payload: value,
  };
}

export function getTaskStatus(value) {
  return {
    type: GET_TASK_STATUS,
    payload: value,
  };
}

export function getRoutesByDate(value) {
  return {
    type: GET_ROUTES_BY_DATE,
    payload: value,
  };
}

export function reorderRoute(value) {
  return {
    type: REORDER_ROUTE,
    payload: value,
  };
}

export function insertJobToRoute(value) {
  return {
    type: INSERT_JOB_TO_ROUTE,
    payload: value,
  };
}

export function updateJobLocation(value) {
  return {
    type: UPDATE_JOB_LOCATION,
    payload: value,
  };
}

export function compareRouteStrategies(value) {
  return {
    type: COMPARE_ROUTE_STRATEGIES,
    payload: value,
  };
}

export function lockRoute(value) {
  return {
    type: LOCK_ROUTE,
    payload: value,
  };
}

export function deleteRoute(value) {
  return {
    type: DELETE_ROUTE,
    payload: value,
  };
}

export function optimizeFromLocation(value) {
  return {
    type: OPTIMIZE_FROM_LOCATION,
    payload: value,
  };
}

export function clearRouteOptimizationState() {
  return {
    type: CLEAR_ROUTE_OPTIMIZATION_STATE,
  };
}

export function setSelectedRoute(value) {
  return {
    type: SET_SELECTED_ROUTE,
    payload: value,
  };
}

export function clearSelectedRoute() {
  return {
    type: CLEAR_SELECTED_ROUTE,
  };
}

